import request from '@/utils/request'

let Sign_upApi = {

  /*签约列表*/
  list(data) {
    return request._post('/shop/plus.sign_up.Index/index', data);
},
/*添加签约*/
add(data) {
    return request._post('/shop/plus.sign_up.Index/add', data);
},
review(data) {
    return request._post('/shop/plus.sign_up.Index/review', data);
},
/*修改签约*/
edit(data) {
    return request._post('/shop/plus.sign_up.Index/edit', data);
},
/*删除签约*/
del(data) {
    return request._post('/shop/plus.sign_up.Index/del', data);
},
/*签约详情*/
detail(data) {
  return request._post('/shop/plus.sign_up.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.sign_up.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.sign_up.Setting/getSetting', data, errorback);
    },
}
export default Sign_upApi;



// WEBPACK FOOTER //
// ./src/api/sign_up.js